import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "title" }
const _hoisted_2 = { class: "overline mt-2" }
const _hoisted_3 = { class: "white--text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_progress_linear = _resolveComponent("v-progress-linear")!
  const _component_v_btn_icon = _resolveComponent("v-btn-icon")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_timeline_item = _resolveComponent("v-timeline-item")!
  const _component_v_timeline = _resolveComponent("v-timeline")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, {
    "grid-list-md": "",
    fluid: "",
    class: "pt-0"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_timeline, {
        "align-top": "",
        dense: ""
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item, i) => {
            return (_openBlock(), _createBlock(_component_v_timeline_item, {
              color: _ctx.checkColor(item),
              icon: _ctx.checkIcon(item),
              key: i
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_row, {
                  justify: "space-between",
                  class: "elevation-2 mr-2 pa-2",
                  style: {"background-color":"#fafafa"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, { class: "pr-0 text-left py-0" }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.getTitle(item)), 1),
                        _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.getDescription(item)), 1)
                      ]),
                      _: 2
                    }, 1024),
                    _createVNode(_component_v_col, {
                      cols: "2",
                      class: "pl-2 pr-0 py-0"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", null, _toDisplayString(_ctx.getRecurrence(item)), 1)
                      ]),
                      _: 2
                    }, 1024),
                    _createVNode(_component_v_col, {
                      cols: "4",
                      class: "pl-2 pr-0 py-0"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_progress_linear, {
                          rounded: "",
                          height: 25,
                          color: "primary",
                          "model-value": item.percentage
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("strong", _hoisted_3, _toDisplayString(item.missingCount + " / " + item.neededCount), 1)
                          ]),
                          _: 2
                        }, 1032, ["model-value"])
                      ]),
                      _: 2
                    }, 1024),
                    _createVNode(_component_v_col, {
                      cols: "1",
                      class: "text-center pl-2 py-0"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_btn_icon, {
                          icon: "$remove_red_eye",
                          color: "secondary",
                          onClick: _withModifiers(($event: any) => (_ctx.showDetails(item)), ["stop"])
                        }, null, 8, ["onClick"])
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 2
            }, 1032, ["color", "icon"]))
          }), 128))
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}